/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Rules_TitleInputs */



/**
* | output |
* | --- |
* | "VTES Comprehensive Rules" |
*
* @param {Help_Rules_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_rules_title = /** @type {((inputs?: Help_Rules_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Rules_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles complètes de VTES")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reglas completas de VTES")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regras completas de VTES")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regole complete di VTES")
	return /** @type {LocalizedString} */ ("VTES Comprehensive Rules")
});